import React from 'react';
import { tickets } from 'data/weraise-data/sponsored-list-data';
import SponsorShipList from './sponsorship-content/SponsorShipList';

const UnSponsoredList = () => {
  return (
    <SponsorShipList
      data={tickets}
      title="Unsponsored"
      initialLayout="cardview"
    />
  );
};

export default UnSponsoredList;
